// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Vuex from 'vuex'
import store from './store'
Vue.use(Vuex)
import router from './router'

// 引入 babel-plyfill
import "babel-polyfill"
import 'font-awesome/css/font-awesome.min.css'
import VueHtml5Editor from 'vue-html5-editor'


// 在入口文件中（main.js），导入组件库
import vueHashCalendar from 'vue-hash-calendar'
// 引入组件CSS样式
import 'vue-hash-calendar/lib/vue-hash-calendar.css'

import * as Utils from '@/utils'
Vue.prototype.$utils = Utils

// 注册组件库
Vue.use(vueHashCalendar)

// 七牛
if (!localStorage.getItem('token')) {
  var xhr = new XMLHttpRequest();
  xhr.open('post', '/bear-scale/api/qiniu/obtainPictureUploadToken.json' );
  xhr.setRequestHeader("Content-type","application/x-www-form-urlencoded");
//发送请求
  xhr.send('');
  xhr.onreadystatechange = function () {
    // console.log(xhr)
    // 这步为判断服务器是否正确响应
    if (xhr.readyState == 4 && xhr.status == 200) {
      let data=JSON.parse(xhr.responseText)
      // token=data.token
      localStorage.setItem('token',data.token)
    }
  };
}




Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    store,
  template: '<App/>',
  components: { App }
})

// console.log(Vue)




// WEBPACK FOOTER //
// ./src/main.js